// extracted by mini-css-extract-plugin
export default {"relevant-kind":"relevant-kind--EeV_1","left-icon":"left-icon--BZwGE","right-icon":"right-icon--lo0Uw","brand-scroll":"brand-scroll--VxmzF"};